import { useCallback, useEffect, useRef, useState } from "react";

// How long the slide-down lasts; keep in step with .sheet-closing in theme.css
export const SHEET_CLOSE_MS = 260;

/**
 * Closes a bottom sheet with a slide-down instead of it vanishing.
 *
 * Any open keyboard is dismissed first, so the sheet slides away over a settled
 * screen rather than racing the keyboard down.
 *
 * const { closing, requestClose } = useSheetDismiss(() => setShowSheet(false));
 */
const useSheetDismiss = (close) => {
  const [closing, setClosing] = useState(false);
  const timersRef = useRef([]);

  useEffect(
    () => () => {
      timersRef.current.forEach(clearTimeout);
    },
    []
  );

  const requestClose = useCallback(() => {
    if (closing) return;

    const active = document.activeElement;
    const hasKeyboard = active && typeof active.blur === "function" && /^(INPUT|TEXTAREA|SELECT)$/.test(active.tagName);
    if (hasKeyboard) active.blur();

    // let the keyboard start closing before the sheet moves
    const startDelay = hasKeyboard ? 120 : 0;
    timersRef.current.push(
      setTimeout(() => {
        setClosing(true);
        timersRef.current.push(
          setTimeout(() => {
            setClosing(false);
            close();
          }, SHEET_CLOSE_MS)
        );
      }, startDelay)
    );
  }, [close, closing]);

  return { closing, requestClose };
};

export default useSheetDismiss;
